import React, { useState } from 'react';
import styled from 'styled-components';
import UnsplashCredit from '../../../Unsplash/UnsplashCredit';
import ViewerErrorBoundary from '../common/ViewerConclusion/ViewerErrorBoundary';
const ImageWrapper = styled.div `
    text-align: center;

    img {
        max-width: 100%;
    }
`;
const CaptionWrapper = styled.div `
    display: flex;
    align-items: center;
    text-align: center;
    flex-direction: column;
    font-size: ${(props) => props.theme.fonts.textSizeStandard};
    color: ${(props) => props.theme.colors.textSecondary};
`;
const DEFAULT_UNSPLASH_IMAGE_ALT = 'Skill Unsplash Image';
/**
 * DEPRECATED: Now a part of the ImageViewer
 */
const UnsplashImageViewer = ({ componentValues }) => {
    var _a;
    const [hidden, setHidden] = useState(false);
    if (!(componentValues === null || componentValues === void 0 ? void 0 : componentValues.imageUrl) || hidden) {
        return null;
    }
    const onError = () => {
        setHidden(true);
    };
    const renderCaption = () => {
        if (componentValues === null || componentValues === void 0 ? void 0 : componentValues.caption) {
            return React.createElement("p", null, componentValues === null || componentValues === void 0 ? void 0 : componentValues.caption);
        }
        return null;
    };
    return (React.createElement(ViewerErrorBoundary, null,
        React.createElement(ImageWrapper, null,
            React.createElement("img", { src: componentValues === null || componentValues === void 0 ? void 0 : componentValues.imageUrl, onError: onError, alt: (_a = componentValues === null || componentValues === void 0 ? void 0 : componentValues.caption) !== null && _a !== void 0 ? _a : DEFAULT_UNSPLASH_IMAGE_ALT }),
            React.createElement(CaptionWrapper, null,
                renderCaption(),
                React.createElement(UnsplashCredit, { profile: componentValues === null || componentValues === void 0 ? void 0 : componentValues.profile, photographer: componentValues === null || componentValues === void 0 ? void 0 : componentValues.photographer })))));
};
export default UnsplashImageViewer;
//# sourceMappingURL=index.js.map